import nProgress from "nprogress";
import "nprogress/css/nprogress.css";

nProgress.configure({ showSpinner: false });

export { nProgress };
